import GrayCard from "components/gray-card";
import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import TrackItem from "../track-item";
import { ITrackRelease, Track } from "types/musicData";
import { SongWithUrls } from "types/response-type";

interface IProps {
  track?: SongWithUrls;
  tracks?: SongWithUrls[];
  type: string;
}
const TrackList = ({ tracks, track, type }: IProps) => {
  return (
    <Container>
      <GrayCard title="Track List" fullWidth>
        <TableContainer>
          <thead>
            <tr>
              <th scope="col">
                <Typography size="s" ml="2">
                  #
                </Typography>
              </th>
              <th scope="col" style={{ width: "6%" }}>
                <Typography size="s">PLAY</Typography>
              </th>
              <th scope="col" style={{ width: "20%" }}>
                <Typography size="s">TITLE(VERSION) / ARTIST(S)</Typography>
              </th>
              <th scope="col">
                <Typography size="s">PLAIN LYRICS</Typography>
              </th>
              <th scope="col">
                <Typography size="s">SYNCED LYRICS</Typography>
              </th>
              <th scope="col">
                <Typography size="s">CREDITS</Typography>
              </th>
              <th scope="col" style={{ width: "10%" }}>
                <Typography size="s">DOWNLOAD</Typography>
              </th>
              <th scope="col">
                <Typography size="s">ISRC</Typography>
              </th>
              <th scope="col" style={{ width: "15%" }}></th>
            </tr>
          </thead>
          <tbody>
            {track && type === "SINGLE" ? (
              <TrackItem
                no="1"
                title={track?.title}
                artist={track?.primaryArtist.name}
                audio={track?.masterTrackPath}
                id={track.id}
                type={type}
              />
            ) : (
              tracks?.map((track, index) => (
                <TrackItem
                  key={index}
                  no={String(index + 1)}
                  title={track.title}
                  artist={""}
                  id={track.id}
                  audio={track.masterTrackPath}
                  type={"CONTAINER"}
                />
              ))
            )}
          </tbody>
        </TableContainer>
      </GrayCard>
    </Container>
  );
};

export default TrackList;

const Container = styled.div`
  width: 100%;
  margin-top: 3.2rem;
`;

const TableContainer = styled.table`
  width: 100%;
  color: white;
  border-collapse: collapse;

  @media only screen and (max-width: 769px) {
    width: 100rem;
  }

  tr {
    position: relative;

    &:nth-child(odd) {
      background-color: ${Colors.grey700};
      height: 0.8rem;
      //i'm using an empty row here for space
    }
    &:nth-child(even) {
      background-color: ${Colors.grey600};
    }
    td {
      &:first-child {
        border-top-left-radius: 1rem;
        border-bottom-left-radius: 1rem;
      }
      &:last-child {
        border-top-right-radius: 1rem;
        border-bottom-right-radius: 1rem;
      }
    }
  }
  th {
    text-align: left;
    color: ${Colors.grey500};
    padding: 1rem 0;
    background-color: #282727;
    cursor: auto;
  }
  thead {
    position: relative;
  }

  td {
    color: white;
    padding: 0.8rem 0;
  }
  tbody {
    overflow-y: visible;
  }
`;
